import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';

const RoleDetail = () => {
  const navigate = useNavigate();

  const rows = [
    {
      id: 1,
      name: "Dashboard",
      view: true,
      add: true,
      edit: true,
      delete: false
    },
    // You can add more module permissions here
  ];

  return (
    <>
      <div className="main_title">
        <h1>Role Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>
          {" "} - <button onClick={() => navigate("/manage-subadmin")}>Manage Sub-Admin</button>
          {" "} - <button onClick={() => navigate("/manage-subadmin/roles")}>Manage Roles</button>
          {" "} - Role Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="gap_p">
          <div className="w_33">
            <h6>Role Name</h6>
            <p>Role 1</p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>01 March 2025</p>
          </div>
        </div>

        <TableContainer className="table_container mt_20">
          <Table>
            <TableHead>
              <TableRow hover>
                <TableCell>Module Name</TableCell>
                <TableCell align="center">View</TableCell>
                <TableCell align="center">Add</TableCell>
                <TableCell align="center">Edit</TableCell>
                <TableCell align="center">Delete</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow hover key={row.id}>
                  <TableCell>{row.name}</TableCell>
                  <TableCell align="center">
                    {row.view ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />}
                  </TableCell>
                  <TableCell align="center">
                    {row.add ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />}
                  </TableCell>
                  <TableCell align="center">
                    {row.edit ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />}
                  </TableCell>
                  <TableCell align="center">
                    {row.delete ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default RoleDetail;
